
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFuse01Off as ObiFuse01OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fuse-01-off.js';
 
 
 

 
 export const ObiFuse01Off = createComponent({
   react: React,
   tagName: 'obi-fuse-01-off',
   elementClass: ObiFuse01OffElement,
   events: {
     
   }
  });
 
 